module.exports = __webpack_public_path__ + "static/media/19ESCAP49.29e4036b.jpg";